<div (click)="onContainerClicked($event)" class="basic modal fade {{modalClass}}" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
     [ngStyle]="{
     'display': (visible ? 'block' : 'none'),
     'opacity': (visibleAnimate ? 1 : 0),
     'z-index': zIndex
     }">
  <div class="modal-dialog" [ngClass]="dialogClass" >
    <div [ngClass]="{'modal-content': !hideBackground}">
      <div *ngIf="!hideHeader" class="modal-header">
        <ng-content select=".app-modal-header"></ng-content>
      </div>
      <div class="modal-body">
        <ng-content select=".app-modal-body"></ng-content>
      </div>
      <div *ngIf="!hideFooter" class="modal-footer">
        <ng-content select=".app-modal-footer"></ng-content>
      </div>
    </div>
  </div>
</div>
